/**
 * Converts an ALL-CAPS company name (as returned by Brønnøysundregistrene)
 * to Title Case, with special handling for common Norwegian legal suffixes
 * that should remain in uppercase (AS, ASA, SA, ANS, DA, ENK, NUF, BA, SE).
 */
export const deCapsifyCompanyName = (companyName: string): string => {
    const UPPERCASE_SUFFIXES = ['AS', 'ASA', 'SA', 'ANS', 'DA', 'ENK', 'NUF', 'BA', 'SE']

    const titleCased = companyName
        .split(' ')
        .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
        .join(' ')

    for (const suffix of UPPERCASE_SUFFIXES) {
        const titleSuffix = suffix.charAt(0).toUpperCase() + suffix.slice(1).toLowerCase()
        if (titleCased.endsWith(` ${titleSuffix}`)) {
            return titleCased.slice(0, -(titleSuffix.length + 1)) + ` ${suffix}`
        }
    }

    return titleCased
}
